/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { STAGE } from '../../config';
import { AllRolesList } from '../../pages/ManageInstitutionUsers/roles';

const ViewAllRoles = ({ selectedRoles, userTypeVal, userType }) => {
    const [listOfRoles, setListOfRoles] = useState({});
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate()
    
    const getSelectedRoleList = () => {            
        try {

            if (userTypeVal) {
                let role = [];
                Object.entries(AllRolesList).map(([item, subitems]) => {
                    role.push({ [item]: subitems });
                });
                setListOfRoles([...role]);
            } else {
                const filteredRoles = Object.entries(AllRolesList).map(([item, subitems]) => {
                    if (subitems.length === 0) {
                        const key = item.toLowerCase().replace(/\s/g, '-');
                        return selectedRoles?.includes(key) ? { [item]: [] } : null;
                    }
                    const filteredSubitems = subitems.filter(subitem => {
                        const key =(item === "Employees" && subitem === "Directory ") ? 'employee-directory' : item === "Students-Activity" && subitem === "Directory" ? 'directory' :
                            (item === "Employees" && subitem === "Attendance") ? 'employees-attendance' :
                                (item === "Students-Activity" && subitem === "Attendance") ? 'students-attendance' :
                                    item === "Students-Activity" && subitem === "Academic Reports" ? 'academic-reports' :
                                        subitem.toLowerCase().replace(/\s/g, '-');
                        return selectedRoles?.includes(key);
                    });
                    return filteredSubitems?.length > 0 ? { [item]: filteredSubitems } : null;
                }).filter(Boolean);
                setListOfRoles(filteredRoles);
            }
            setLoading(false);
        } catch (error) {
            navigate('/404');
        }
    };
    

    useEffect(() => {
        getSelectedRoleList();
    }, [AllRolesList]);

    return (
        <>
            {!loading && <div className="border border-[#C2DCEF] flex flex-wrap rounded p-4" >
                <div class="flex -mx-0.5 flex-wrap w-full">
                    {listOfRoles.map((role,i)=>{
                        const roleName = Object.keys(role)[0];
                        const items = role[roleName];
                        return(
                            <>
                                <div class={`px-0.5 w-1/4 mb-4 ${i<4?'mb-5':''}`} key={i}>
                                    <div class="w-full" style={{display:`${role==='Institution' &&branch?'none':''}`}}>
                                        <p class="text-f7 font-semibold text-[#031624] mb-1">{roleName}</p>
                                        {items.map((item,i)=>(
                                            <div class="relative checkbox custom-checkBoxBlueBranch mb-1 flex" key={item}>
                                                <p className="text-f7 font-normal text-[#031624]">{item}</p>

                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </>
                        )
                    })}
                </div>
               
                
            </div>}

        </>
    );
};

export default ViewAllRoles;
